import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { SITE_NAME } from "@/seo/site";

export default function NotFoundPage() {
  const { t } = useTranslation("common");
  // Without this the 404 inherits whatever the previous page set — title,
  // description, canonical and the whole SportsEvent JSON-LD graph — while still
  // saying robots=index,follow. The CDN also can't return a real 404 (unknown paths
  // fall back to the home snapshot), so `noindex` is the only thing keeping mistyped
  // URLs out of the index. Passing no canonical/jsonLd now actively CLEARS the
  // previous page's, see useDocumentMeta.
  useDocumentMeta({
    title: `Page not found | ${SITE_NAME}`,
    description: "The page you are looking for does not exist.",
    noindex: true,
  });
  return (
    <section className="container py-24 text-center">
      <p className="text-xs uppercase tracking-[0.25em] text-primary font-semibold">404</p>
      <h1 className="mt-3 text-5xl md:text-6xl">{t("notFound.title")}</h1>
      <p className="mt-4 max-w-md mx-auto text-muted-foreground">
        {t("notFound.body")}
      </p>
      <div className="mt-8">
        <Link to="/"><Button size="lg">{t("notFound.cta")}</Button></Link>
      </div>
    </section>
  );
}
